import { ProjectChangesDateLog } from '../../../../domain/projectChangesDateLog/projectChangesDateLog';
import DateField from '../../../shared/components/forms/DateField';
import TextAreaField from '../../../shared/components/forms/TextAreaField';
import ProjectStatusSelector from '../selectors/ProjectStatusSelector';

interface Props {
    projectChanges: ProjectChangesDateLog;
    onChange: (
        name: string,
        value: string | boolean | number[] | number | undefined
    ) => void;
}

export default function ModalProjectChangesSection({
    projectChanges,
    onChange: handleInputChange,
}: Props) {
    return (
        <>
            <div className='col-12'>
                <DateField
                    label='Nueva Fecha'
                    name='newDate'
                    onChange={handleInputChange}
                    required={true}
                    value={projectChanges.newDate}
                    key='newDate'
                />
            </div>
            <div className='col-12'>
                <ProjectStatusSelector
                    value={projectChanges.projectStatusId}
                    name='projectStatusId'
                    onChange={handleInputChange}
                />
            </div>
            <div className='col-12'>
                <TextAreaField
                    name='comments'
                    value={projectChanges.comments}
                    label='Motivo'
                    required={false}
                    onChange={handleInputChange}
                    key='comments'
                />

                <div className="comment-counter">
                    {projectChanges.comments.length} caracteres
                </div>
            </div>
        </>
    );
}
